import { render } from "./sale.vue?vue&type=template&id=fcab69a8&scoped=true"
import script from "./sale.vue?vue&type=script&lang=js"
export * from "./sale.vue?vue&type=script&lang=js"

import "./sale.vue?vue&type=style&index=0&id=fcab69a8&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcab69a8"]])

export default __exports__